import React from 'react';
import { withI18n } from 'react-i18next';
import {
  DropdownMenu, IconInvoice,
} from 'gatorcomponents';
import { Modal } from '@/pages/common/Modal';
import * as Styles from './ModalInvoiceWrapped.styles';

const ModalInvoiceWrapped = ({
  invoiceId,
  nfse,
  onClose,
  t,
}) => {
  const handleOpenLink = url => () => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  };

  return (
    <Modal
      onClose={onClose}
      onGoBack={null}
      borderRadius={16}
      variant="medium"
      maxWidth={800}
    >
      <Styles.Wrapper data-testid="modal-invoice-wrapped">
        <Styles.Header data-testid="modal-invoice-wrapped-header">
          <Styles.Title data-testid="modal-invoice-wrapped-title">{t('nfseTitle')}</Styles.Title>
          <Styles.HeaderInvoiceId data-testid="modal-invoice-wrapped-header-invoice-id">
            <IconInvoice data-testid="modal-invoice-wrapped-header-invoice-id-icon" />
            {invoiceId}
          </Styles.HeaderInvoiceId>
        </Styles.Header>
        {nfse && (
          <Styles.List data-testid="modal-invoice-wrapped-list">
            {nfse.map((nota) => {
              if (!nota) return null;

              const dropdownItems = [];
              if (nota.url) {
                dropdownItems.push(
                  {
                    id: 'modal-invoice-list-nfse',
                    label: t('nfseLink'),
                    icon: 'IconOpenEye',
                    onClick: handleOpenLink(nota.url),
                  },
                );
              }

              if (nota.link_pdf) {
                dropdownItems.push(
                  {
                    id: 'modal-invoice-list-pdf',
                    label: t('nfseDownloadPdf'),
                    icon: 'IconDownload',
                    onClick: handleOpenLink(nota.link_pdf),
                  },
                );
              }

              if (nota.link_xml) {
                dropdownItems.push(
                  {
                    id: 'modal-invoice-list-xml',
                    label: t('nfseDownloadXml'),
                    icon: 'IconDownload',
                    onClick: handleOpenLink(nota.link_xml),
                  },
                );
              }

              return (
                <Styles.ListItem key={nota.code} data-testid={`modal-invoice-list-item-${nota.code}`}>
                  <Styles.ListItemNumber data-testid={`modal-invoice-list-item-number-${nota.code}`}>
                    <Styles.ListItemNumberLabel data-testid={`modal-invoice-list-item-number-label-${nota.code}`}>
                      {t('nfseNumber')}
                    </Styles.ListItemNumberLabel>
                    <Styles.ListItemNumberCode data-testid={`modal-invoice-list-item-number-code-${nota.code}`}>
                      {nota.code}
                    </Styles.ListItemNumberCode>
                  </Styles.ListItemNumber>
                  <DropdownMenu
                    testId={`modal-invoice-list-dropdown-${nota.code}`}
                    items={dropdownItems}
                    customPosition="left"
                    noBorder
                  />
                </Styles.ListItem>
              );
            })}
          </Styles.List>
        )}
      </Styles.Wrapper>
    </Modal>
  );
};

export default withI18n()(ModalInvoiceWrapped);
